var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDovetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M.377 12.464a.067.067 0 0 0 0 .116l4.179 2.413a.13.13 0 0 1 .066.115v4.825c0 .052.056.084.1.058l4.179-2.413a.13.13 0 0 0 .066-.116V12.6a.13.13 0 0 0-.066-.115l-4.279-2.47zM.377 2.43a.067.067 0 0 0 0 .115l4.179 2.413a.13.13 0 0 1 .066.116v4.94l4.345-2.51v-4.94a.13.13 0 0 0-.066-.115L4.689.018a.13.13 0 0 0-.133 0zM8.967 7.505l4.279 2.47a.13.13 0 0 1 .066.116v4.825c0 .051.056.083.1.058l4.179-2.414a.13.13 0 0 0 .066-.115V7.582a.13.13 0 0 0-.066-.116l-4.212-2.43a.13.13 0 0 0-.133 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDovetail);
export default __webpack_public_path__ + "static/media/Dovetail.0fd9001939603c723ca452e23375cb3a.svg";
export { ForwardRef as ReactComponent };